export type UnitIconType = "infantry" | "armor" | "air" | "navy";

export const unitIconPaths: Record<UnitIconType, string> = {
  infantry: "/assets/units/infantry.png",
  armor: "/assets/units/armor.png",
  air: "/assets/units/air.png",
  navy: "/assets/units/navy.png",
};

interface UnitIconProps {
  unit: UnitIconType;
  className?: string;
}

export function UnitIcon({ unit, className = "" }: UnitIconProps) {
  return (
    <img
      className={`unit-icon unit-icon-${unit} ${className}`.trim()}
      src={unitIconPaths[unit]}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}
